import { render, staticRenderFns } from "./StaffCode.vue?vue&type=template&id=0c4c6b76&scoped=true&"
import script from "./StaffCode.vue?vue&type=script&lang=js&"
export * from "./StaffCode.vue?vue&type=script&lang=js&"
import style0 from "./StaffCode.vue?vue&type=style&index=0&id=0c4c6b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c6b76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4c6b76')) {
      api.createRecord('0c4c6b76', component.options)
    } else {
      api.reload('0c4c6b76', component.options)
    }
    module.hot.accept("./StaffCode.vue?vue&type=template&id=0c4c6b76&scoped=true&", function () {
      api.rerender('0c4c6b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/StaffCode.vue"
export default component.exports